import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  compose,
  lifecycle,
  setPropTypes,
  withHandlers,
  withState
} from 'recompose';
import { bindActionCreators } from 'redux';
import { Typography } from '@material-ui/core';
import ReactSelectMaterialUi from 'react-select-material-ui';
import GroupDetailTableGroup from '../../components/molecules/GroupDetailTableGroup';
import CloseButton from '../../components/atoms/CloseButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { languages, languageType } from '../../constants/Language';

const styles = {
  root: {
    // position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    top: '5%',
    // left: '2%',
    backgroundColor: '#fff',
    overflow: 'auto',
    outline: 'none',
    borderRadius: 4
  },
  titleDetail: {
    fontSize: 20,
    fontWeight: 'bold',
    margin: 40,
    marginBottom: 20
  },
  btnClose: {
    margin: '0px 30px 30px 30px'
  },
  selectContainer: {
    marginLeft: 40,
    marginRight: 40
  },
  selectControl: {
    width: '100%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(dispatch => ({
    actions: bindActionCreators({}, dispatch)
  })),
  setPropTypes(propTypes),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withHandlers({}),
  lifecycle({
    componentDidMount() {
      this.props.setIsLanguage(this.props.currentLanguage);
    }
  })
);

const Main = enhance(
  ({
    classes,
    detail,
    backAction,
    editAction,
    openEditProgress,
    progressOkAction,
    loading,
    resultMessage,
    isLanguage,
    setIsLanguage,
    otherData,
    isFukuoka
  }) => {
    const closeAction = () => backAction();
    const multiLangData = { ...detail, ...otherData };
    if (isLanguage !== languageType.ORIGIN) {
      const languageData = detail.otherLanguages.find(
        language => language.language === isLanguage
      );
      if (languageData && languageData.translateType) {
        Object.assign(multiLangData, languageData.params);
      } else {
        Object.assign(multiLangData, {
          groupName: 'Google Translate で自動的に翻訳されるもの',
          address: 'Google Translate で自動的に翻訳されるもの',
          building: 'Google Translate で自動的に翻訳されるもの',
          groupContactName: 'Google Translate で自動的に翻訳されるもの',
          department: 'Google Translate で自動的に翻訳されるもの',
          description: 'Google Translate で自動的に翻訳されるもの'
        });
      }
      Object.assign(multiLangData, {
        address: 'Google Translate で自動的に翻訳されるもの',
        building: 'Google Translate で自動的に翻訳されるもの'
      });
    }
    return (
      <div className={classes.root}>
        <Typography variant="h6" className={classes.titleDetail}>
          グループ情報 編集 確認
        </Typography>
        <div className={classes.selectContainer}>
          <ReactSelectMaterialUi
            required
            className={[classes.textField, classes.selectControl]}
            defaultValue={isLanguage}
            value={isLanguage}
            options={languages}
            margin="normal"
            onChange={v => {
              if (isLanguage === v) {
                return;
              }
              setIsLanguage(v);
            }}
          />
        </div>

        <div>
          <GroupDetailTableGroup detail={multiLangData} isFukuoka={isFukuoka} />
        </div>
        <div className={classes.btnClose}>
          <CloseButton onClickAction={closeAction} />
          {/* <RegisterButton onClickAction={editAction} /> */}
          <ConfirmButton onClickAction={editAction} />
        </div>
        <ProgressDialog
          openProgress={openEditProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
